import * as CONSTANTS from '../constants/constants';

const initialState = {
  loading: false,
  users: [],
  user: {},
  students: []
};


const allUsers = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case CONSTANTS.GET_USERS:
      return Object.assign({}, state, {
        loading: false,
        users: action.users
      });
    case CONSTANTS.GET_USER:
      return Object.assign({}, state, {
        loading: false,
        user: action.user
      });
    case CONSTANTS.GET_STUDENTS:
      return Object.assign({}, state, {
        loading: false,
        students: action.students
      });
    default:
      return state;
  }
};

export default allUsers;
